import React from 'react';
import { FadeIn } from './FadeIn';
import { MapPinIcon, PhoneIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Contact() {
  const contactInfo = [{
    icon: <PhoneIcon size={24} className="text-nova-cyan" data-id="element-13" />,
    title: 'Teléfono / WhatsApp',
    detail: '+54 9 299 519-2151',
    sub: 'Respuesta inmediata'
  }, {
    icon: <MapPinIcon size={24} className="text-nova-cyan" data-id="element-14" />,
    title: 'Ubicación',
    detail: 'Av. Argentina 123, Piso 4',
    sub: 'Neuquén Capital, Argentina'
  }, {
    icon: <ClockIcon size={24} className="text-nova-cyan" data-id="element-15" />,
    title: 'Horarios',
    detail: 'Lunes a Viernes',
    sub: '09:00 - 18:00 hs'
  }, {
    icon: <MailIcon size={24} className="text-nova-cyan" data-id="element-16" />,
    title: 'Email',
    detail: 'hola@novadental.com',
    sub: 'Consultas generales'
  }];
  return <section id="contacto" className="py-24 relative" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6" data-id="element-18">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-19">
          <div data-id="element-20">
            <FadeIn data-id="element-21">
              <h2 className="text-4xl md:text-5xl font-black text-nova-dark mb-6 tracking-tight" data-id="element-22">
                Estamos para <br data-id="element-23" />
                ayudarte
              </h2>
              <p className="text-lg text-nova-gray mb-12" data-id="element-24">
                Visítanos en nuestras modernas instalaciones en el corazón de
                Neuquén. Diseñadas para tu máximo confort.
              </p>
            </FadeIn>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-25">
              {contactInfo.map((info, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
                  <div className="glass-panel p-6 flex flex-col gap-3" data-id="element-27">
                    <div className="w-12 h-12 rounded-xl bg-nova-cyan/10 flex items-center justify-center" data-id="element-28">
                      {info.icon}
                    </div>
                    <div data-id="element-29">
                      <h4 className="font-bold text-nova-dark" data-id="element-30">{info.title}</h4>
                      <p className="text-nova-gray font-medium mt-1" data-id="element-31">
                        {info.detail}
                      </p>
                      <p className="text-sm text-nova-gray/70" data-id="element-32">{info.sub}</p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <FadeIn delay={0.4} direction="left" className="h-full min-h-[400px] rounded-3xl overflow-hidden shadow-glass relative" data-id="element-33">
            {/* Placeholder for a map or clinic image */}
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Recepción de la clínica" className="absolute inset-0 w-full h-full object-cover" data-id="element-34" />
            <div className="absolute inset-0 bg-nova-dark/20" data-id="element-35"></div>
            <div className="absolute bottom-6 left-6 right-6 glass-panel p-6 text-center" data-id="element-36">
              <p className="font-bold text-nova-dark" data-id="element-37">Instalaciones Premium</p>
              <p className="text-sm text-nova-gray" data-id="element-38">
                Estacionamiento exclusivo para pacientes
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}